(function () {
    'use strict';

    angular.module('app')
        .controller('EntityDeleteModalController', EntityDeleteModalController);

    /* @ngInject */
    function EntityDeleteModalController(item, params, ModalService) {
        var vm = this;

        vm.dismiss = ModalService.dismiss;
        vm.item = item;
        vm.params = params;
        vm.confirmRemove = confirmRemove;

        cleanString();

        //Para eliminar caracteres que pueden hacer que no se muestre el texto en la ventana modal
        function cleanString() {
            if (vm.item[vm.params.property]) {
                vm.item[vm.params.property] = vm.item[vm.params.property].replace("'", "");
                vm.item[vm.params.property] = vm.item[vm.params.property].replace("<", "");
                vm.item[vm.params.property] = vm.item[vm.params.property].replace(">", "");
                vm.item[vm.params.property] = vm.item[vm.params.property].replace("&", "");
            }
        }

        function confirmRemove() {
            vm.item.$remove({id: vm.item.id}).then(function () {
                ModalService.close();
            });
        }
    }
})();
